import { error as errorReducer } from './Error.reducer';
import {
    ACCOUNT_SUMMARY_RECEIVE,
    ACCOUNT_SUMMARY_ERROR,
    ACCOUNT_SUMMARY_CURRENT_VIEW,
} from '../Actions/AccountSummary.action';

const defaultState = {
    data: {},
    currentView: 'default',
    dateFrom: '',
    dateTo: '',
    errors: {},
};

export const accountSummary = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case ACCOUNT_SUMMARY_RECEIVE:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case ACCOUNT_SUMMARY_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        case ACCOUNT_SUMMARY_CURRENT_VIEW:
            return {
                ...state,
                currentView: payload.currentView,
                invoiceDateFrom: payload.invoiceDateFrom || '',
                invoiceDateTo: payload.invoiceDateTo || '',
            };
        default:
            return state;
    }
};
